export default __webpack_public_path__ + "static/media/sc.4a156363.svg";